/* eslint-disable prettier */
/**
 * Created by calhosh on 4/14/2017.
 * ZH SP resource file
 */
export const labels = {
	title: "EY Canvas经济性",
	status: "状态",
	header: "标题",
	canvas: "Canvas",
	canvasEconomics: "Canvas 经济",
	badRequest: "无效请求",
	errorBanner: "{0}错误",
	userProfileDropdown: {
		myProfile: "我的配置文档",
		signOut: "注销"
	},
	clientCode: "客户代码",
	hours: "工时",
	local: "本地",
	currency: "货币",
	rate: "费率",
	forecast: "预测",
	variance: "偏差",
	edit: "编辑",
	arrowUp: "向上箭头",
	budget: "预算",
	priorBudget: "前期预算",
	currentBudget: "当期预算",
	summary: "汇总",
	actual: "实际支出",
	priorActual: "前期实际支出",
	currentActual: "当期实际支出",
	remaining: "剩余",
	adjustment: "调整",
	estimate: "估计",
	isRequired: "{0}为必填",
	isPositiveInteger: "{0}为必填，并且必须是非负整数。",
	isPositiveDecimal: "{0}为必填，并且必须是正数，保留两位小数。",
	in: "在",
	id: "ID",
	currentYear: "本年度",
	priorYear: "上年度",
	budgetHierarchy: "预算级次",
	executionBudgetHierarchy: "执行预算级次",
	noContentAvailable: "无可用内容",
	viewMore: "查看更多",
	budgetExecutionPhase: "对{0}内所有对象的预算",
	details: "详细",
	unallocated: "未分配",
	none: "无",
	thousands: "千",
	millions: "百万",
	lakhs: "十万",
	crores: "千万",
	budgetObjectName: "预算对象名称",
	editActivityCodes: "编辑活动编码",
	save: "保存",
	send: "发送",
	cancel: "取消",
	searchActivityCodes: "搜索活动编码",
	noActivityCodesAvailable: "没有可用的活动编码",
	select: "选择",
	engagementCode: "项目编码",
	engagementCodeName: "项目代码名称",
	activityCode: "活动编码",
	activityCodeDescription: "活动编码描述",
	searchActivityCodesPlaceholderText: "搜索活动编码",
	addMember: "添加成员",
	closeLabel: "关闭",
	cancelLabel: "取消",
	seachInputRequired: "搜索输入为必填",
	nameOrEmail: "姓名或邮箱",
	emailForExternal: "邮箱",
	noRecord: "未找到结果",
	userSearchPlaceholder: "输入姓名或邮箱，然后按回车键查看结果。",
	userSearchPlaceholderForExternal: "输入邮箱，然后按回车键查看结果。",
	clearAllValues: "清除所有值",
	clear: "清空",
	inValidEmail: "请输入有效的邮箱",
	invalidClientCode: "无效客户编码",
	railSearchText: "搜索",
	open: "打开",
	remove: "删除",
	leave: "离开",
	delete: "删除",
	markAsCompleted: "标记为已完成",
	budgetedHours: "预算的工时",
	forecastedHours: "预测工时",
	actualHours: "实际工时",
	ftaVariance: "FTA差异",
	ftaVarianceTooltip: "预测用时与实际用时差值",
	usedHours: "使用的工时数",
	etcHours: "预计完成时间小时数",
	createProjectCard: "创建项目",
	plusClients: "+{0}客户",
	plusCodes: "+{0}客户编码  ",
	clientNames: "客户名称： ",
	clientName: "客户名称： ",
	clientNameLabel: "客户名称",
	clientCodes: "客户编码： ",
	clientCodeCard: "客户编码： ",
	financialAnalysis: "财务分析",
	billingExpenses: "账单和费用",
	independence: "独立性 ",
	timeChargedCanvasIndependenceStatus: "EY Canvas的整体项目独立性状态和财务编码",
	independenceStatusFromCanvasLabel: "EY Canvas中显示的独立性状态",
	independenceRequired: "要求具备独立性 ",
	validatedCanvas: "已在EY Canvas中验证",
	notInvited: "未获得邀请 ",
	notApplicable: "不适用",
	incomplete: "不完整 ",
	other: "其他 ",
	financialCodesDisplayed: "显示的财务代码 ",
	independenceStatusChangeReasonLabel: "更改状态",
	independenceStatusChangeReasonDescription: "为所选的项目组成员选择完成原因。",
	changeReasonLabel: "原因",
	clarificationLabel: "澄清（可选）",
	characterCount: "200个字符的{0}个字符",
	expandAll: "全部展开",
	collapseAll: "全部折叠",
	canvasEngagements: "EY Canvas项目",
	independenceCompleted: "已完成的独立性 ",
	engagementName: "项目名称 ",
	engagementIndependenceStatus: "按项目独立性状态排列 ",
	noAssociatedClients: "无相关客户",
	noCanvasEngagementsIdentified: "没有识别到EY Canvas项目。",
	placeholderForSearch: "搜索项目组成员",
	exportToExcel: "导出到Excel ",
	all: "全部 ",
	updateSelected: "更新所选项目 ",
	updateAll: "更新全部 ",
	customizeTable: "自定义表格 ",
	canvasEngagementName: "EY Canvas项目名称",
	displayBy: "按xxx显示数据",
	financialDetails: "财务信息",
	actualHoursToDate: "迄今实际工时",
	byWeekEndingDate: "每周结束日期",
	ClickAndDrag: "点击和拖放图中某个区域以放大查看",
	etc: "估计的完成时长",
	auditProgress: "EY Canvas进度",
	tasksAndMilestones: "任务和里程碑",
	milestonesOverdue: "逾期里程碑",
	milestoneOverdue: "逾期里程碑",
	inProgress: "进行中",
	inReview: "复核中",
	Complete: "完成",
	assignments: "工作分配",
	assignment: "工作分配",
	assignmentsOverdue: "已逾期的任务",
	assignmentOverdue: "逾期的工作分配",
	overdue: "逾期",
	requestOverdue: "逾期请求",
	requestsOverdue: "逾期请求",
	total: "合计",
	complete: "完成",
	closed: "已关闭",
	Unassigned: "未分配",
	unassigned: "未分配",
	sent: "已发送",
	totalTask: "总任务",
	collaboration: "协作",
	received: "已接收",
	accepted: "已接受",
	outstanding: "未完成",
	unsentDrafts: "未发送的草稿",
	draft: "草稿",
	drafts: "草稿",
	returned: "已退回",
	draftRequests: "请求草稿",
	percent: "百分比",
	preparer: "编制人",
	reviewer: "复核人",
	NoDataForSelectedOptions: "所选选项没有可用信息。",
	NoAssignmentDataForSelectedOptions: "项目没有使用工作分配功能",
	NoCollabDataForSelectedOptions: "项目没有使用协作功能",
	tasks: "任务",
	totalTasks: "总任务",
	requests: "请求",
	requestSent: "已发送请求",
	requestsSent: "已发送请求",
	expandDetails: "展开详细信息",
	onlyProjectAdministratorsCanEdit: "仅项目管理员可以编辑",
	onlyProjectAdministratorsCanDelete: "仅项目管理员可以删除项目",
	userOptions: "用户选项",
	userOptionsDropdown: {
		userSettings: "用户设置",
		delegateAccess: "管理受托人",
		privacyNotice: "隐私声明",
		signOut: "注销"
	},
	delegateToInstruction: "将访问权限委托给同事，以便其代你验证项目代码。委托人将能够验证你有权访问的所有项目代码。",
    delegateFromInstruction: "以下用户已委托其验证项目代码的权限。",
	delegateAccess: "管理受托人",
	addDelegates: "添加受托人",
	addAnother: "添加新的受托人",
	hideMyDelegate: "隐藏经我授权的受托人",
	showMyDelegate: "显示经我授权的受托人",
	duplicateUser: "该受托人已被添加",
	informationRequired: "该信息为必填",
	delegateTo: "受托人",
	delegateFrom: "委托人",
	noDelegatesAdded: "未添加受托人",
	noDelegationReceived: "未收到委托。",
	removeDelegateMessgae: "请确定是否删除该受托人？删除后，该受托人将不可再代你验证财务项目代码。", 
    removeDelegateTitle: "删除受托人",
	delegate: "受托人",
	saveAndClose: "保存并关闭",
	resetZoom: "重置显示比例",
	exportData: "导出数据",
	rankCode: "级别代码",
	userGui: "用户GUI",
	email: "邮箱",
	globalAnsr: "ANSR（全球）",
	globalCost: "成本（全球）",
	globalMargin: "利润（全球）",
	localAnsr: "ANSR（本地）",
	localCost: "成本（本地）",
	localMargin: "利润（本地）",
	weekEnding: "周结束日期",
	welcomeToEconomics: "欢迎访问EY Canvas Economics",
	adminPortal: "管理端",
	home: "主页",
	enterFirstNameText: "请输入用户姓名或邮箱地址，并点击回车键搜索",
	addBtn: "添加",
	cancelBtn: "取消",
	close: "关闭",
	selectRole: "角色",
	upsText: "Ups!",
	sufficientRightsToAccess: "你没有访问该页面的权限",
	detailedInformation: "由于提供数据的时间不同，数据明细与汇总数据可能有所差异。",
	noResultFound: "未找到符合搜索条件的结果",
	loading: "正在加载...",
	search: "搜索",
	softwareUpdate: "软件更新",
	updateLater: "稍后更新",
	updateNow: "立即更新",
	updateMsg: "EY Canvas Economics有可用的软件更新。选择立即更新，下载并安装更新。页面将被刷新。",

	eycanvasEngagements: "EY Canvas项目",
	eycanvasEngagement: "EY Canvas项目",
	expandView: "展开视图",
	noFinancialCodesDisplay: "没有可显示的财务代码",
	expand: "展开",
	collapse: "折叠",
	bulkSendIndependenceLabel: "批量发送独立性确认函",
	independenceStatusInviteUserLabel: "仅将内部项目组成员添加为独立性",
	independenceStatusInviteUserDescription: "在下方确定项目组成员的角色。该用户将被添加到具有“仅独立性”限制的{0}Canvas项目中，并将被通知完成独立性确认函。",
	clickToInviteUser: "发送独立性确认函",
	click: "点击",
	invitePending: "待邀请",
	engagementRolePlaceholder: "项目角色",
	engagementRoleRequiredErrorMessage: "请为所选项目组成员选择项目角色",
	engagementInvitationSuccessToastMessage: "您已成功发送独立性确认函。",
	engagementInvitationFailureToastMessage: "独立性确认函发送失败，请重试。如问题仍然存在，请联系帮助台。",
	independenceInviteConfirmationMessage: "已发送独立性确认函。待回复。",
	engagementRoleRequiredOverAllErrorMessage: "尚未为一个或多个用户选择项目角色。从下拉列表中选择项目角色，再继续发送独立性确认函。",
	administrativeContractor: "行政合同制员工",
};

export const errors = {
	default: "发生错误。请联系帮助台。",
	102: "无效项目。",
	106: "RBAC授权被拒绝。",

	1001: "未找到用户。",
	1002: "用户获取全部指令失败。",
	1003: "用户GUI不能为空。",
	1004: "请求不得为空。",
	1005: "无法创建用户，存在和该用户有相同GUI的用户。",
	1006: "找到多个有相同GUI的用户。",
	1007: "该用户不是活跃用户。请刷新页面并重试。如仍有错误，请联系帮助台。",
	1008: "选择的数字格式无效。请刷新页面并重试。如仍有错误，请联系帮助台。",
	1009: "选择的取整格式无效。请刷新页面并重试。如仍有错误，请联系帮助台。",
	1010: "选择的货币格式无效。请刷新页面并重试。如仍有错误，请联系帮助台。",
	1011: "选择的日期格式无效。请刷新页面并重试。如仍有错误，请联系帮助台。",
	1012: "选择的语言无效。请刷新页面并重试。如仍有错误，请联系帮助台。",
	1013: "名字过短或过长。请重试。",
	1014: "姓氏过短或过长。请重试。",
	1015: "选择的负数格式无效。请刷新页面并重试。如仍有错误，请联系帮助台。",
	1016: "用户不存在，无法更新。",
	1017: "获得用户首选项时发生错误。API指令失败。",
	1018: "在创建用户时发生了错误。API指令失败。",
	1019: "更新用户首选项时发生错误。API指令失败。",
	1020: "用户不是活跃用户。刷新页面，然后重试。如果仍有错误，请联系帮助台。",
	1021: "所选主题值无效。刷新页面，然后重试。如果仍有错误，请联系帮助台。",
	1022: "所选货币值无效。刷新页面，然后重试。如果仍有错误，请联系帮助台。",
	1023: "用户无权从项目中删除已请求的项目组成员。",
	1024: "在创建委托用户时发生了错误。API指令失败。",
	1025: "委托用户列表不能为空。",
	1026: "用户名太长或太短。",
	1027: "用户GUI无效。",
	1028: "用户邮件地址太长或太短。",
	1029: "用户ID不能为空。",
	1030: "用户名不能为空。",
	1031: "用户邮件地址不能为空。",
	1032: "用户不在被授予删除访问权限的委托人之列。",
	1033: "用户不在授予删除访问权限的授予委托人之列。",
	1034: "用户已在委托人之列。",
	1035: "用户ID长度不符合规则。请重新输入正确的用户ID。",
	1036: "登录的用户不在列表中。请稍后重试。",
	1040: "你没有管理员权限。请联系帮助台。",

	7001: "项目元数据指令失败。",
	7006: "EY Canvas目前无法访问。刷新页面，然后重试。如果问题仍然存在，请联系帮助台。",

	8003: "从CDS API获得项目详细信息时出错。",
	8006: "EY Canvas目前无法访问。刷新页面，然后重试。如果问题仍然存在，请联系帮助台。",
	8004: "未找到项目代码。如果是Mercury代码，请确保其中包括项目类型。  请重试，如果问题仍然存在，请联系帮助台。",
	8007: "从CDS API获取项目详情时出错。",
	8008: 'Connection failed. Refresh and try again. If the issue persists, contact the Help desk.',

	9001: "请求不能为空",
	9002: "项目客户代码信息栏不能为空",
	9003: "项目名称信息栏不能为空。",
	9004: "百分比信息栏不能为空。",
	9005: "费率信息栏不能为空。",
	9006: "预算没有关联任何选定的项目。",
	9007: "项目唯一识别符不能为空。",
	9008: "项目客户名称不能为空。",
	9009: "项目描述不能为空。",
	9010: "项目客户唯一识别符不能为空。",
	9011: "关联的项目系统不能为空。",
	9012: "关联项目唯一识别符不能为空。",
	9013: "关联项目名称不能为空。",
	9014: "关联项目客户唯一识别符不能为空。",
	9015: "关联项目客户名称不能为空。",
	9016: "添加的关联项目不能为空。",
	9017: "一个或多个EY Canvas项目无效。",
	9018: "一个或以上相关项目代码无效。",
	9019: "项目百分比应大于零。",
	9020: "项目百分比不应超过两位小数。",
	9021: "项目费率应大于零。",
	9022: "项目ID无效。",
	9023: "获得财务分析指令失败。",
	9024: "未找到项目详细信息",
	9025: "获得标题指令失败。",
	9026: "未找到符合搜索条件的结果。",
	9027: "无效汇总类型。",
	9028: "当前用户没有项目访问权限。",
	9029: "未找到项目收费账单的详细信息。",
	9030: "未找到项目财务信息筛选工具。",
	9031: "用户名过长或过短。",
	9032: "用户GUI无效。",
	9033: "用户邮箱地址过长或过短。",
	9034: "项目小组至少应有一位成员拥有项目管理员权限。",
	9035: "你是该项目的最后一位活跃项目管理员用户。删除该项目，将其从你的登陆页中移除。如无法删除，请联系帮助台。",
	9036: "请删除一个或多个EY Canvas项目。数量超过{0}。",
	9037: "项目组成员总数已超过{0}个上限，请删除一部分成员。",
	9038: "项目代码总数已超过{0}个上限，请删除一部分项目代码。",
	9039: "项目用户数量必须大于零。",
	9040: "未经验证的财务代码”不得为空值或空字符串，且其长度不能超过50个字符。",
	9041: "项目ID不能为空。",
	9042: "无法完成删除操作。请重试，如果仍有错误，请联系帮助台。",
	9043: "当前用户没有编辑项目所需的权限。",
	9044: "获取项目具体财务信息指令失败。",
	9045: "项目状态无效。",
	9046: "项目用户状态无效。",
	9047: "无效的项目用户角色",
	9048: "项目名称不得超过500个字符。",
	9049: "项目用户名字不能为空。",
	9050: "项目用户姓氏不能为空。",
	9051: "项目用户GUI不能为空。",
	9052: "项目用户邮箱不能为空。",
	9053: "项目用户admin flag不能为空。",
	9054: "不能将特权账户添加为项目用户。",
	9055: "未找到“项目费用筛选”。",
	9056: "项目独立性修补程序请求正文不能为空。",
	9058: "财务代码无效。",
	9063: "已完成独立性中存在无效理由值。",
	9064: "已完成独立性类型存在无效值。",
	9065: "未找到“项目费用筛选”。",
	9066: "项目链接的项目ID数量超过允许的最大值。",
	9067: "修补程序操作无效。",
	9068: "部分用户已更新状态，请刷新页面以查看最新状态。",
	9069: "独立性修补程序API失败。",
	9070: "重复的与Canvas项目关联的财务代码。",
	9071: "仅可将与Canvas项目关联的单个财务代码标记为主代码。",
	9072: "与Canvas项目关联的主财务代码无效。",
	9073: "重复的未验证财务代码。",
	9074: "重复用户。",
	9075: "用户电子邮件无效。",
	9076: "项目用户创建人请求正文不能为空。",
	9077: "项目用户创建请求有重复用户。",
	9078: "项目用户角色无效。",
	9079: "无效Canvas项目。",
	9080: "项目未匹配至项目。",
	9081: "项目用户创建人请求失败。",
	9082: "由于处于非活动状态，会话已超时。请刷新页面重试。如仍有问题，请联系帮助台。",

	/*Admin error codes*/
	14001: "未找到用户",
	14002: "管理员用户指令失败",
	14003: "管理员用户不活跃",
	14004: "管理员用户创建失败",
	14005: "名字过短或过长，请重试",
	14006: "姓氏过短或过长，请重试",
	14007: "管理员角色ID无效",
	14008: "所选择用户已经是管理员。请查看。",
	14009: "管理员用户搜索指令失败",
	14010: "用户GUI不得为空",
	14011: "用户GUI必须大于零",
	14012: "用户ID无效，请重试",
	14013: "邮件地址无效，请重试",
	14014: "登录的用户与管理员用户不是同一用户",
	14015: "管理项目搜索指令失败",
	14016: "管理员用户已存在，但不活跃",
	14017: "管理员只能是特权用户账户。",
	14018: "管理员角色ID不得为空。",
	14019: "登录的用户不是系统管理员。",
	14020: "请求者的特权账户无效。",
	14021: "管理员只能是特权用户账户。",
	14023: "删除现有管理员角色时出错。",
	14024: "添加更新的管理员角色时出错。",
	14025: "管理员用户ID不得为空。",

	/*PAANS error codes*/
	15001: "安永政策的授权、批准和通知服务暂不可用。我们无法确认是否所有相关政策均已完成。如您尚未复核相关政策，请刷新页面并重试。如果问题仍然存在，请联系帮助台。"
};

export const roundingOptions = [{
	value: 'none',
	label: "无"
},
{
	value: 'thousands',
	label: "千"
},
{
	value: 'millions',
	label: "百万"
},
{
	value: 'lakhs',
	label: "十万"
},
{
	value: 'crores',
	label: "千万"
}
];

export const displayLanguages = [{
	displayLanguageId: 1,
	label: "英语",
	value: 'en-us'
},
{
	displayLanguageId: 4,
	label: "法语",
	value: 'fr-ca'
},
{
	displayLanguageId: 5,
	label: "西班牙语",
	value: 'es'
},
{
	displayLanguageId: 7,
	label: "葡萄牙语",
	value: 'pt-br'
},
{
	displayLanguageId: 8,
	label: "日语",
	value: 'ja'
},
{
	displayLanguageId: 9,
	label: "中文（简体）",
	value: 'zh-cn'
},
{
	displayLanguageId: 10,
	label: "中文（繁体）",
	value: 'zh-tw'
},
{
	displayLanguageId: 11,
	label: "希伯来语",
	value: 'he'
},
{
	displayLanguageId: 12,
	label: "韩语",
	value: 'ko'
}
];

export const numberFormats = [{
	value: '1,234,567,890',
	label: "数值类型1",
	title: '1,234,567,890'
},
{
	value: '1.234.567.890',
	label: "数值类型3",
	title: '1.234.567.890'
},
{
	value: '1,23,45,67,890',
	label: "数值类型7",
	title: '1,23,45,67,890'
},
{
	value: '1 234 567 890',
	label: "数值类型2",
	title: '1 234 567 890'
}
];

export const dateFormats = [{
	value: 'MM/dd/yyyy',
	label: 'MM/DD/YYYY'
},
{
	value: 'dd/MM/yyyy',
	label: 'DD/MM/YYYY'
},
{
	value: 'yyyy/MM/dd',
	label: 'YYYY/MM/DD'
}
];

export const negativeNumberFormats = [{
	value: '(1.1)',
	label: '(1.1)'
},
{
	value: '-1.1',
	label: '-1.1'
},
{
	value: '- 1.1',
	label: '- 1.1'
},
{
	value: '1.1-',
	label: '1.1-'
},
{
	value: '1.1 -',
	label: '1.1 -'
}
];

export const currencyFormats = [{
	value: "全球",
	label: "全球"
},
{
	value: "本地",
	label: "本地"
}
];

export const themeOptions = {
	light: "浅色",
	dark: "深色"
};

export const currencyOptions = {
	global: "全球",
	local: "本地"
};

export const currencyDisplayOptions = [{
	value: 'Global',
	label: "全球"
},
{
	value: 'Local',
	label: "本地"
}
];

export const statusValues = [{
	isActive: true,
	label: "活跃"
},
{
	isActive: false,
	label: "非活跃"
}
];

export const financialOptions = {
	serviceLine: "业务线",
	subServiceLine: "子业务线",
	teamMember: "项目组成员",
	rank: "职级"
};

export const roles = {
	1: "审计负责合伙人",
	2: "项目合伙人",
	3: "执行总监",
	4: "负责人",
	5: "高级经理",
	6: "经理",
	7: "高级审计员",
	8: "审计员",
	9: "实习生",
	10: "项目质量复核人",
	11: "其他合伙人",
	12: "GDS——审计员",
	13: "咨询（ITRA、TAS、人力资本或其他）",
	14: "税务",
	15: "管理支持服务",
	16: "总法律顾问",
	17: "审计质量复核人",
	21: "内部审计主管",
	22: "内部审计职员",
	23: "监管者",
	24: "其他（如，尽职调查复核）",
	25: "事务所",
	26: "地区",
	27: "行业",
	28: "国际",
	29: "全球",
	30: "GDS-高级审计员",
	31: "GDS-经理"
};

export const serviceLines = [{
	value: 0,
	label: "所有业务线"
},
{
	value: 1,
	label: "咨询"
},
{
	value: 2,
	label: "审计"
},
{
	value: 3,
	label: "法务"
},
{
	value: 4,
	label: "交易咨询服务"
},
{
	value: 5,
	label: "税务"
},
{
	value: 6,
	label: "其他"
}
];

export const serviceLinesByServiceLineCode = [{
	code: 'Not available',
	label: "不可用"
},
{
	code: 'ASU',
	label: "审计"
},
{
	code: 'TAS',
	label: "策略和交易"
},
{
	code: 'TAX',
	label: "税务"
},
{
	code: 'ADV',
	label: "咨询"
},
];

export const userRanks = [{
	id: '11',
	name: "合伙人"
},
{
	id: '12',
	name: "合伙人"
},
{
	id: '13',
	name: "执行总监"
},
{
	id: '21',
	name: "高级经理"
},
{
	id: '32',
	name: "经理"
},
{
	id: '36',
	name: "税务经理"
},
{
	id: '4',
	name: "外派员工"
},
{
	id: '41',
	name: "高级审计员/高级咨询员3级"
},
{
	id: '42',
	name: "高级审计员/高级咨询员"
},
{
	id: '43',
	name: "审计员/咨询员2级"
},
{
	id: '44',
	name: "审计员/咨询员"
},
{
	id: '45',
	name: "高级审计员/高级咨询员2级"
},
{
	id: '46',
	name: "审计员/咨询员3级"
},
{
	id: '49',
	name: "专员"
},
{
	id: '5',
	name: "Administrative contractor"
},
{
	id: '51',
	name: "实习生"
},
{
	id: '52',
	name: "行政支持人员"
},
{
	id: '53',
	name: "实习生（CBS）"
},
{
	id: '55',
	name: "行政主管"
},
{
	id: '56',
	name: "行政专员"
},
{
	id: '57',
	name: "行政高级助理"
},
{
	id: '58',
	name: "行政助理"
},
{
	id: '61',
	name: "总监"
},
{
	id: '62',
	name: "高级经理"
},
{
	id: '63',
	name: "经理"
},
{
	id: '64',
	name: "主管专员"
},
{
	id: '65',
	name: "高级专员"
},
{
	id: '66',
	name: "专员"
},
{
	id: 'Not available',
	name: "不可用"
}
];

export const financialAnalysis = {
	noResultFound: "没找到所选选项的结果",
	allServiceLines: "所有业务线",
	allSubServiceLines: "所有子业务线",
	allMembers: "所有成员",
	allAvailable: "全部可用",
	allAdded: "已全部添加",
	selectAll: "选择全部",
	noResult: "未发现结果",
	noneSelected: "无选择",
	clearAllSeleted: "清空已选择# ",
	showSelected: "显示已选择项目",
	allRanks: "所有职级"
};

export const independenceStatus = [{
	value: 1,
	label: "未完成——未被邀请"
},
{
	value: 2,
	label: "未完成——进行中"
},
{
	value: 3,
	label: "已完成——其他"
},
{
	value: 4,
	label: "已完成——已在在EY Canvas中验证"
}
];

export const eycanvasIndependenceStatus = [{
	value: 1,
	label: "不完整"
},
{
	value: 2,
	label: "未识别事项"
},
{
	value: 3,
	label: "已识别事项——待采取行动"
},
{
	value: 4,
	label: "已解决事项——拒绝访问权限"
},
{
	value: 5,
	label: "已解决事项——授予访问权限"
},
{
	value: 6,
	label: "不适用"
},
{
	value: 7,
	label: "已恢复"
},
{
	value: 8,
	label: "覆盖"
},
{
	value: 9,
	label: "上期——未识别事项"
},
{
	value: 10,
	label: "上期——已识别事项——待采取行动"
},
{
	value: 11,
	label: "上期——已解决事项——授予访问权限"
},
{
	value: 12,
	label: "上期——已解决事项——拒绝访问权限"
}
];

export const availableUserRoles = [{
	value: 1,
	label: "项目负责合伙人",
	displayOrder: 9
},
{
	value: 2,
	label: "项目合伙人",
	displayOrder: 8
},
{
	value: 3,
	label: "执行总监",
	displayOrder: 5
},
{
	value: 4,
	label: "总监",
	displayOrder: 6
},
{
	value: 5,
	label: "高级经理",
	displayOrder: 4
},
{
	value: 6,
	label: "经理",
	displayOrder: 3
},
{
	value: 7,
	label: "高级审计师",
	displayOrder: 2
},
{
	value: 8,
	label: "审计员",
	displayOrder: 1
},
{
	value: 10,
	label: "项目质量复核人",
	displayOrder: 10
},
{
	value: 11,
	label: "其他合伙人",
	displayOrder: 7
},
{
	value: 12,
	label: "GDS-审计员",
	displayOrder: 13
},
{
	value: 16,
	label: "法律总顾问",
	displayOrder: 12
},
{
	value: 17,
	label: "审计质量复核人",
	displayOrder: 11
},
{
	value: 30,
	label: "GDS-高级审计员",
	displayOrder: 14
},
{
	value: 31,
	label: "GDS-经理",
	displayOrder: 15
}
]

export const employmentStatus = [{
	value: 'A',
	label: "活跃"
},
{
	value: 'D',
	label: 'Terminated'
},
{
	value: 'L',
	label: 'Leave of Absence'
},
{
	value: 'T',
	label: 'Terminated'
},
{
	value: 'P',
	label: 'Leave of Absence'
},
{
	value: 'R',
	label: 'Terminated'
},
{
	value: 'U',
	label: 'Leave of Absence'
},
]

export const independenceStatusDropdown = [{
	label: "未完成",
	options: [{
		value: 1,
		label: "未完成——未被邀请"
	},
	{
		value: 2,
		label: "未完成——进行中"
	}
	]
},
{
	label: "完成",
	options: [{
		value: 3,
		label: "已完成——其他"
	}]
}
];

export const customizedTableOptions = [{
	id: 2,
	label: "EY Canvas独立性状态"
},
{
	id: 3,
	label: "成员所"
},
{
	id: 4,
	label: "国家"
},
{
	id: 5,
	label: "已计费工时数 （Hours Charged）"
},
{
	id: 6,
	label: "总体独立性状态"
},
{
	id: 7,
	label: "确认日期"
},
{
	id: 8,
	label: "雇佣状态"
},
{
	id: 9,
	label: "更新人"
},
{
	id: 10,
	label: "更新日期"
}
];

export const independenceStatusChangeReasons = [{
	value: 1,
	label: "在EY Canvas之外完成——未识别任何事项",
	isDisplayed: true
},
{
	value: 7,
	label: "在EY Canvas之外完成——已识别事项",
	isDisplayed: true
},
{
	value: 8,
	label: "在EY Canvas之外完成——已解决事项",
	isDisplayed: true
},
{
	value: 2,
	label: "业务始终涵盖人员",
	isDisplayed: true
},
{
	value: 3,
	label: "已从事务所离职",
	isDisplayed: true
},
{
	value: 4,
	label: "休假",
	isDisplayed: true
},
{
	value: 5,
	label: "解雇",
	isDisplayed: false
},
{
	value: 6,
	label: "其他",
	isDisplayed: false
}
];

export const common = {
	selected: "已选定",
	cancel: "取消",
	checkbox: {
		selectAllOn: "选择全部",
		selectAllOff: "取消全部选择"
	},
	clear: "清空",
	close: "关闭",
	nav: {
		projectName: "项目名称"
	},
	pagination: {
		show: "显示",
		iconHover: {
			first: "第一页",
			previous: "上一页",
			next: "下一页",
			last: "最后页"
		}
	},
	search: {
		clear: "清空搜索",
		buttonTitle: "搜索",
		placeholder: "搜索",
		noResultsPlaceholder: "未发现结果"
	},
	table: {
		remove: "删除",
		noDataPlaceholder: "无可用数据",
		noResultsPlaceholder: "未发现结果"
	},
	toggleSwitch: {
		no: "否",
		yes: "是"
	},
	wizard: {
		next: "继续",
		back: "返回",
		finish: "完成"
	},
	unsavedChanges: "未保存变动",
	unsavedChangesDescription: "你有未保存变动，如选择继续，变动将丢失。是否确认要取消这些变更？"
};

export const project = {
	myProjects: "我的项目",
	priorProjects: "前期项目",
	searchForBudgets: "搜索",
	emptyContainer: "您没有任何活跃预算。选择“创建预算”，然后开始。",
	noResultsFound: "未找到结果。",
	create: {
		title: "创建项目",
		clientCode: "客户编码",
		clientCodeInfo: "镜像编码无法被识别。使用发出编码的系统中的代码（即Mercury或GFIS）。",
		clientName: "客户名称",
		clientNamePlaceholder: "输入客户编码，搜索客户名称",
		name: "项目名称",
		rate: "默认每小时费率",
		rateInfo: "将使用默认的每小时费率计算预算的工时数。费率计算方法为开票服务费除以预计总工时。",
		percentage: "预计变现百分比",
		percentageInfo: "预期的变现百分比将用于计算Mercury或GFIS计费的小时数的时间价值。 ",
		relateEngagementsInstructionalText: "选择将用于此项目的一个或多个EY Canvas项目。这些项目的统计数据将和财务数据一同展示。只显示目前可以访问的项目。",
		selectClientAndWorkspaceInstructionalText: "选择客户和工作区，筛选出将与本项目关联的EY Canvas项目。",
		engagementPanelPlaceholder: "选择客户和工作区，显示建议的项目。",
		engagementPanelNoResultsFound: "未找到结果",
		emptyEngagements: "无可用的EY Canvas项目。在EY Canvas创建一个新项目，然后开始。",
		selectClient: "选择客户",
		selectWorkspace: "选择工作区",
		selectEngagements: "选择项目",
		selectedEngagements: "已添加项目",
		selectedEngagementError: "选择一个或多个项目然后继续",
		searchEngagements: "搜索项目",
		searchUsers: "搜索用户",
		engagementLabel: "{0} | ID: {1}",
		addBtn: "添加",
		removeBtn: "删除",
		clientLbl: "客户",
		engagementCodeLbl: "项目编码",
		engagementTypeCodeLbl: "项目类型",
		engagementNameLbl: "项目名称",
		engagementId: "ID",
		addedByLbl: "添加人",
		engagementDescriptionLbl: "项目说明",
		systemLbl: "系统",
		noEngagementsLabel: "将项目编码关联至本项目。",
		step4InstTxt: "选择一个或多个项目编码与项目相关联。",
		relatedEngagementCodesSubtitle: "已关联项目编码",
		relatedEngagementCodeLink: "关联Mercury或GFIS的项目编码。镜像编码无法被识别。",
		unauthorizedModalHeader: "未授权用户",
		unauthorizedText: "您未被授权实施关联操作",
		allowedUsersText: "有权进行此操作的人员列表如下所示。",
		closeBtn: "关闭",
		validateBtn: "验证",
		relatedEngagementAddLabel: "关联Mercury或GFIS的项目编码。镜像编码无法被识别。",
		todayLbl: "今天",
		NoEmailMessage: "未提供邮箱",
		noEngagementsAdded: "未添加项目",
		selectToImport: "选择EY Canvas项目，将用户导入至此项目。",
		addMember: "如果用户不是EY Canvas项目的活跃用户，请{0}以添加该用户。",
		addedMembers: "已添加成员",
		employeeName: "成员",
		role: "职能",
		manageTeamInstructionalText: "从关联的EY Canvas项目中选择活跃的项目组成员，按照以下说明添加未加入EY Canvas项目的其他项目组成员。",
		currentUser: "当前用户",
		canvasEngagements: "EY Canvas项目",
		wizardSteps: [
		{
			stepName: "步骤1",
			stepDescription: "输入项目详细信息",
			active: true
		},
		{
			stepName: "步骤2",
			stepDescription: "选择EY Canvas项目"
		},
		{
			stepName: "步骤3",
			stepDescription: "管理访问权限",
			relatedEngagementCodesSubtitle: "已关联项目编码",
			relatedEngagementCodeLink: "关联Mercury或GFIS的项目编码。镜像编码无法被识别。",
			unauthorizedModalHeader: "未授权用户",
			unauthorizedText: "您未被授权实施关联操作",
			allowedUsersText: "以下为可执行此操作的人员列表。",
			close: "关闭"
		},
		{
			stepName: "步骤4",
			stepDescription: "连接至Mercury/GFIS"
		},
		{
			stepName: 'Step 5',
			stepDescription: "将项目代码关联至EY Canvas项目",
			isExit: true
		}
		],
		ratePerHour: "每小时费率",
		realizationPercentage: "变现百分比"
	},
	stepOne: {
		enterProjectName: "输入项目名称然后继续"
	},
	stepTwo: {
		addCanvasEngagements: "将EY Canvas项目添加至项目",
		editCanvasEngagements: "将EY Canvas项目编辑至项目",
		selectCanvasEngagements: "已显示您有权访问的EY Canvas项目。  请选择一个或多个将加入项目的EY Canvas项目。",
		noCanvasEngagements: "没有可用的EY Canvas项目。请前往下一步以继续项目设置。",
		noCanvasEngagementsSelected: "没有已选择的EY Canvas项目",
		noSearchResultsFoundLeftRail: "未找到结果",
		clientName: "客户",
		workspace: "Workspace",
		engagementCode: "项目代码",
		canvasEngagementName: "EY Canvas项目",
		changes: "变动",
		tooltipMessages: {
			clientName: "客户名称",
			clientCode: "客户代码",
			engagementCode: "项目代码",
			engagementDescription: "项目名称",
			workspaceID: "Workspace ID",
			workspaceDescription: "Workspace名称"
		}
	},
	stepThree: {
		editTeamMembers: "编辑项目的项目组成员。",
		editTeamMembersWhoWillHaveAccess: "编辑有权访问项目的项目组成员。如想添加不属于已关联EY Canvas项目的项目组成员，请使用右侧的搜索功能。项目管理员将获得项目管理权限（如添加或移除项目组成员）。",
		addTeamMembers: "向项目添加项目组成员。",
		addTeamMembersWhoWillHaveAccess: "添加将获得项目访问权的项目组成员。如想添加不属于已关联EY Canvas项目的项目组成员，请使用右侧的搜索功能。项目管理员将获得项目管理权限（如添加或移除项目组成员）。",
		noCanvasEngagementsSelected: "没有已选择的EY Canvas项目",
		noSearchResultsFoundLeftRail: "未找到结果",
		addOtherTeamMembers: "添加不属于已关联EY Canvas项目的其他小组成员",
		member: "成员",
		projectAdministrator: "项目管理员",
		clickHere: "点击此处",
		nameOrEmail: "姓名或邮箱",
		addNewMember: "添加",
		firstName: "名字",
		lastName: "姓氏",
		inviteAndClose: "邀请并关闭",
		inviteAndAddAnother: "邀请并添加另一个",
		clear: "清空"
	},
	stepFour: {
		engagementCode: "项目代码",
		clientName: "客户",
		validation: "状态",
		independenceOnly: "仅独立性",
		noEngagementCodes: "没有为项目添加项目代码",
		addNewMember: "添加",
		addEngagementManually: "添加项目代码",
		addEngagementCodes: "添加项目代码",
		editEngagementCodes: "编辑项目代码",
		validateEngagement: "验证是否已添加了所有项目代码。你只能验证GFIS/Mercury中你有权访问的项目代码。若项目代码被识别为 \'仅独立性\'，则与该项目代码相关的详细信息（如项目小组成员和相关计费工时）将包含在此Economics项目的独立性摘要中，但不包含在财务相关信息中。",
		informationalMessage: "对于Mercury，在项目代码中添加项目类型前缀（如E-12345678）",
		noCanvasEngagements: "没有已添加至项目的EY Canvas项目",
		engagementCodePlaceholder: "输入项目代码",
		validate: "验证",
		engagementCodeRequired: "项目代码为必填项",
		searchNoResults: "未找到结果"
	},
	stepFive: {
		title: "将项目代码关联至EY Canvas项目",
		description: "关联至各已关联EY Canvas项目的主要项目代码显示如下。如想向某EY Canvas项目关联其他项目代码，请使用拖放功能。",
		financialCodes: {
			searchButtonTitle: "搜索",
			searchButtonPlaceholder: "按照财务项目代码搜索",
			header: "项目代码",
			noRecords: "没有识别到项目代码",
			canvasEngagements: "EY Canvas项目",
			noResults: "未找到结果"
		},
		canvasEngagements: {
			searchButtonTitle: "搜索",
			clearButtonTitle: "清除",
			noResults: "未找到结果",
			searchButtonPlaceholder: "按照客户或EY Canvas项目搜索",
			header: "客户和项目",
			noRecords: "没有关联至项目的EY Canvas项目",
			noEngagementCodes: "没有关联的项目代码",
			primary: "主要",
			displayUnassociatedEngagements: "显示没有关联财务代码的EY Canvas项目"
		}
	},
	deleteProject: "删除项目",
	deleteDescription: "是否确定针对所有用户删除该项目？",
	deleteDescText: "此操作无法撤销。",
	delete: "删除",
	cancel: "取消",
	close: "关闭",
	confirm: "确定",
	leaveProject: "离开",
	leaveDescription: "是否确认离开该项目？你的项目组成员仍可继续访问该项目。",
	change: "变动",
	changes: "变动"
};

export const users = {
	settings: {
		title: "用户设置",
		firstName: "名字",
		lastName: "姓氏",
		displayLanguage: "显示语言",
		numberFormat: "数字格式",
		negativeNumberFormat: "负数格式",
		currencyFormat: "货币格式",
		dateFormat: "日期格式",
		roundingFormat: "取整格式",
		save: "保存",
		cancel: "取消",
		errorMessageSelect: "请选择一个值。",
		errorMessageInput: "请输入有效值。",
		isRequired: " 必填。",
		preferences: "首选项",
		yourDelegates: "您的委托人",
		yourDelegatesDescription: "您授权可以在Mercury或GIFS中按照项目编码（您当前有访问权限）检索财务数据的用户",
		delegationsFromOthers: "其他成员委托",
		delegationsFromOthersDescription: "授权您可以在Mercury或GIFS中按照项目（用户当前有访问权限）检索财务数据的用户",
		noUsersIdentified: "未找到用户",
		addADelegate: "添加委托人",
		theme: "主题",
		preferredCurrency: "首选货币",
		status: "状态"
	}
};

export const projectSummary = {
	filter: {
		filterFinancialAuditData: "筛选客户",
		filter: "筛选",
		searchPlaceholder: "搜索",
		searchClearHoverText: "清空",
		searchHoverText: "搜索",
		unvalidated: "未验证",
		noData: "没有关联的EY Canvas项目",
		noResults: "未发现结果",
		noInformationAvailable: "所选选项没有可用信息。",
		independence: "独立性 ",
		noDataFound: "没有找到数据",
	},
	roundingType: "取整： ",
	roundingFormats: {
		none: "无",
		thousands: "千",
		millions: "百万",
		lakhs: "十万",
		crores: "千万"
	},
	updatedDateType: {
		financialDateLabel: "财务数据",
		updatedOn: "更新日期",
		canvasDateLabel: "EY Canvas数据"
	},
	keyPerformanceIndicators: {
		noValue: '-',
		totalEngagementRevenue: {
			ter: "项目总收入",
			actualTER: "实际项目总收入",
			billed: "已开账单",
			actualBilling: "实际账单金额",
			totalEngagementRevenue: "项目总收入（服务费+费用）",
			forecastedTER: "预测的项目总收入"
		},
		margin: {
			margin: "利润",
			target: "目标"
		},
		globalDeliveryService: {
			gds: "GDS使用情况",
			globalDeliveryService: "全球交付中心"
		}
	},
	currency: "货币： ",
	globalCurrency: "全球",
	localCurrency: "本地",
	noDataAvailable: "在选定筛选条件下无可用数据",
	actualHours: "实际时长",
	etc: "ETC",
	ftaVariance: "FTA偏差",
	completedTasks: "已完成任务",
	closedAssignments: "已关闭工作分配",
	acceptedRequests: "已接受请求",
	gDSUsage: "GDS使用情况",
	summaryHeaderPartner: "合伙人",
	summaryHeaderPpedd: "PPEDD",
	summaryHeaderExecutive: "主管",
	financialProgressCard: {
		financialProgress: "财务进度",
		financialDetails: "财务细节",
		ansr: "ANSR",
		nsr: "NSR",
		ansrTooltip: "已调整的净标准收入（净服务收费，不包括费用）",
		nsrTooltip: "净标准收入（个人净标准费率乘以工时）",
		eafTooltip: "项目调整因素",
		cost: "成本",
		hours: "小时",
		expandDetails: "展开详细信息",
		expand: "展开",
		collapse: "收起",
		collapseDetails: "收起详细信息",
		margin: "利润",
		marginPercentage: "利润",
		rphAcronym: "RPH",
		cphAcronym: "CPH",
		mphAcronym: "MPH",
		eafAcronym: "EAF",
		actual: "实际",
		budgeted: "预算",
		forecasted: "预测",
		ftaVariance: "FTA偏差",
		ftaVarianceTooltip: "预测值与实际值偏差",
		rph: "每小时费率",
		cph: "每小时成本",
		mph: "每小时利润",
		ansrCost: "净标准收入（NSR）/成本",
		serviceLine: "业务线",
		subServiceLine: "子业务线",
		teamMember: "项目组成员",
		totalAnsr: "净标准收入总额",
		totalCost: "总成本",
		totalHours: "总小时",
		ansrLabelText: "净标准收入",
		rank: "职级",
		performanceActuals: "实际绩效"
	},
	financialAnalysis: {
		show: "显示",
		first: "第一个",
		last: "最后一个",
		previous: "上一步",
		next: "下一步"
	},
	financialFilters: {
		serviceLine: "业务线",
		subServiceLine: "子业务线",
		rank: "职级",
		teamMember: "项目组成员",
		showMore: "更多",
		clear: "清空",
		clearAll: "清除全部",
		search: "搜索",
		noResultsPlaceholder: "无结果",
		noFiltersAvailable: "无筛选",
		yes: "是",
		no: "否",
		tooltip: "筛选",
		expenseType: "费用类型"
	},
	billingAndExpenses: {
		title: "Actual billings to date",
		forecastedTer: "TER预测",
		forecastedTerTooltip: "预计项目总收入（服务收费+费用）",
		forecastedBilling: "预测账单",
		collected: "已收取",
		collectedTooltip: "已收取/已开账单",
		unCollected: "未收款",
		unCollectedTooltip: "未收取/已开账单",
		billed: "已开账单（逾期）",
		billedTooltip: "已开账单/预测的项目总收入",
		billedTotal: "已开账单",
		unbilled: "未开账单",
		unbilledTooltip: "未开账单/预测的项目总收入",
		engagementCode: "项目代码",
		invoiceDate: "发票日期",
		currency: "货币 ",
		invoiceNumber: "发票编码",
		amount: "金额",
		noInformationPlaceholder: "所选项没有可用信息",
		actualTer: "实际项目总收入",
		actualTerTooltip: "实际项目总收入（服务收费+费用）",
		actualExpenseToDate: "迄今实际费用",
		displayBy: "选择按哪项内容显示数据",
		expenseType: "费用类型",
		teamMember: "项目组成员",
		totalExpenseToDate: "迄今合计费用",
		expenseTypeColumn: "费用类型",
		teamMemberColumn: "项目组成员",
		globalExpenseAmount: "全球费用金额",
		localExpenseAmount: "本地费用金额",
		billingSummary: "账单开具记录汇总",
		billingStatus: "账单开具状态",
		billingTER: "项目总收入",
		serviceLine: "业务线",
		serviceLineColumn: "业务线",
		rank: "职级",
		rankColumn: "职级"
	},
	independence: {
		teamMember: "项目组成员",
		hoursCharged: "计费工时 ",
		independenceStatus: "总体独立性状态",
		confirmationDate: "确认日期 ",
		memberFirm: "成员所",
		eyCanvasIndependenceStatus: "EY Canvas独立性状态",
		employmentStatus: "雇佣状态",
		country: "国家",
		updatedBy: "更新人",
		updatedDate: "更新日期",
		selectColumns: "选择列",
		confirmationDateBefore: "确认日之前",
		confirmationDateAfter: "确认日之后",
		excelsummary: "汇总",
		excelMercury: "Mercury的日期",
		excelCanvas: "Canvas的日期",
		name: "名称",
		gui: "GUI",
		rank: "职级",
		emailAddress: "邮件地址",
		clarification: "澄清",
		explanation: "解释",
		updatedOn: "更新日期",
		client: "客户",
		mercuryEngagementCode: "Mercury项目代码",
		canvasEngagement: "Canvas项目",
		email: "邮件",
		reason: "原因",
		engagementRole: "项目角色",
		location: "位置",
		filter: {
			unassociatedFinancialCodes: "未关联的财务代码",
			unassociatedLabel: "未关联",
			filterHeader: "独立性筛选工具",
			noFinancialCodeLabel: "没有关联的财务代码",
			noEngagementLabel: "没有关联的EY Canvas项目",
			expandText: "展开",
			collapseText: "折叠",
			noDataFound: "未找到数据"
		}
	},
	header: {
		hours: "小时",
		actualHours: "实际",
		forecastedHours: "预测",
		variance: "FTA偏差",
		other: "其他",
		ppedd: "PPEDD",
		mgrSrMgr: "高级经理/审计经理",
		partnerHours: "合伙人工时",
		executiveDirector: "执行总监",
		seniorManager: "高级经理",
		manager: "经理",
		senior: "高级审计员",
		staff: "审计员",
		intern: "实习生",
		billed: "已开账单：",
		ter: "项目总收入：",
		forecastedTER: "预测的项目总收入:",
		margin: "利润",
		ansr: "ANSR",
		cost: "成本",
		terSection: "项目总收入",
		billedSection: "已开账单",
		forecastedTERSection: "预测",
		forecastedTERSectionForHeader: "预测的项目总收入",
		completedTasks: "已完成任务",
		completedAssignments: "已关闭工作分配",
		acceptedRequests: "已接受请求",
		gdsUsage: "GDS使用情况",
		completedTasksTooltip: "已完成",
		totalTasksTooltip: "合计",
		completedAssignmentsTooltip: "已关闭",
		totalAssignmentsTooltip: "合计",
		acceptedRequestsTooltip: "已接受",
		sentRequestsTooltip: "已发送",
		gdsHoursTooltip: "GDS",
		actualHoursTooltip: "实际工时",
		otherTooltip: "其他",
		otherHeaderTooltip: "其他",
		ppeddTooltip: "PPEDD",
		mgrSrMgrTooltip: "高级经理/经理",
		partnerHoursTooltip: "合伙人/主管",
		executiveDirectorTooltip: "执行总监/总监",
		seniorManagerTooltip: "高级经理",
		managerTooltip: "经理",
		seniorTooltip: "高级审计员",
		staffTooltip: "审计员",
		internTooltip: "实习生",
		varianceTooltip: "预测值与实际值偏差",
		ansrTooltip: "已调整的净标准收入（净服务收费，不包括费用）",
		marginTooltip: "利润率=（ANSR-成本）/ANSR ",
		terSectionHover: "项目实际总收入（服务费+费用）",
		forecastedTERSectionHover: "项目预测总收入（服务费+费用）",
		billedSectionHover: "实际发票净额",
		gdsUsageHover: "GDS使用情况"
	}
};

export const exportOptions = {
	buttonText: "导出",
	downloadCSV: "下载CSV",
	downloadJPEG: "下载JPEG",
	downloadPDF: "下载PDF",
	downloadPNG: "下载PNG",
	downloadSVG: "下载SVG",
	downloadXLS: "下载XLS",
	exitFullscreen: "退出全屏",
	viewFullscreen: "查看全屏",
	printChart: "打印流程"
};

export const adminLabels = {
	adminPortal: "管理",
	usersTab: "用户管理",
	projectsTab: "项目管理",
	administrators: "管理员管理"
};

export const projectUserStatus = {
	active: "活跃",
	inactive: "不活跃"
};

export const projectUserRoles = {
	defaultUser: "默认用户",
	projectAdministrator: "项目管理员"
};

export const projectStatus = {
	active: "活跃",
	deleted: "已删除"
};

export const administratorRoles = {
	none: "无",
	adminReader: "读取权限管理员",
	adminWriter: "写入权限管理员",
	superAdmin: "超级管理员"
}

export const addUser = {
	firstName: "名字",
	lastName: "姓氏",
	enterFirstNameText: "输入用户名字、姓氏或邮箱，点击回车搜索。",
	selectRole: "角色",
	userRole: "用户角色",
	clear: "清空",
	email: "邮箱",
	role: "角色",
	cancel: "取消",
	addUser: "添加用户",
	close: "关闭",
	add: "添加",
	addAdministrator: "添加管理员",
	error1: "所选用户已经是该项目成员。请查看。",
	error2: "管理员只能是特权用户账户。"
};

export const adminManageProjects = {
	manageProjects: "管理项目",
	description: "输入项目ID以搜索项目",
	projectId: "项目ID",
	search: "搜索",
	clearSearch: "清空",
	enterValidProject: "输入有效的项目ID",
	projectDetails: "项目详细信息",
	enterProjectName: "输入项目名称",
	projectName: "项目名称",
	projectStatus: "项目状态",
	financialCodes: "财务代码",
	noFinancialCodes: "没有和该项目对应的财务项目代码",
	engagementCode: "项目代码",
	client: "客户",
	status: "状态",
	validatedBy: "已验证，验证人：",
	canvasEngagements: "EY Canvas项目",
	canvasEngagement: "EY Canvas项目",
	noCanvasEngagements: "没有和该项目对应的EY Canvas项目",
	member: "成员",
	gui: "GUI",
	firstName: "名字",
	lastName: "姓氏",
	emailAddress: "邮件地址",
	userRole: "用户角色",
	validated: "已验证",
	unvalidated: "未验证",
	enterValidGui: "输入针对项目ID有效的GUI",
	requiredProjectName: "项目名称不能为空",
	successToastMessage: "变动保存成功",
	resetToastMessage: "已重置",
	errorToastMessage: "项目成员中需至少有一位担任项目管理员。请复核变动。",
	independenceOnly: "仅适用于独立性",
	yes: "是",
	no: "否"
};

export const manageAdministrators = {
	title: "管理员管理",
	firstName: "名字",
	lastName: "姓氏",
	email: "邮箱",
	role: "角色",
	description: "添加新管理员或者管理当前管理员",
	noInformationPlaceholder: "所选选项没有可用信息",
	updateAdminErrorToast: "更新失败请检查后重试。",
	updateAdminSuccessToast: "变动保存成功",
};

export const adminManageUsers = {
	title: "用户管理",
	description: "输入用户GUI搜索用户。",
	inputLabel: "用户GUI",
	searchButtonLabel: "搜索",
	cancelButtonLabel: "清空",
	errorMessage: "输入有效用户GUI",
	userDetails: "用户详细信息",
	projects: "项目",
	delegates: "委托人",
	settings: "设置",
	noResultsPlaceholder: "没有找到记录",
	delegatedTo: "委托至：",
	delegatedFrom: "委托授予人：",
	gui: "GUI",
	firstName: "名字",
	lastName: "姓氏",
	emailAddress: "邮件地址",
	projectName: "项目名称",
	projectId: "项目ID"
};

export const adminCommon = {
	save: "保存",
	reset: "重置"
}
